__webpack_require__.p = "https://stake-assets.s3.amazonaws.com/static/dist/";